module.exports = __webpack_public_path__ + "img/DHT.368c4660.svg";